module.exports = __webpack_public_path__ + "img/level.ba25ff01.svg";